/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-west-2",
  aws_cloud_logic_custom: [
    {
      name: "virtiusapisession",
      endpoint: "https://5jpd28ttle.execute-api.us-west-2.amazonaws.com/test",
      region: "us-west-2",
    },
  ],
  aws_appsync_graphqlEndpoint:
    "https://rdjdc2dzjfd65j5ym7p2o5ivrm.appsync-api.us-west-2.amazonaws.com/graphql",
  aws_appsync_region: "us-west-2",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "da2-arutfjj6ircifozvhf4bfkkzou",
  aws_cognito_region: "us-west-2",
  aws_user_pools_id: "us-west-2_ICNXGEsSc",
  aws_user_pools_web_client_id: "71om57u7sramf89va3j5ao2g2k",
  oauth: {},
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS",
    ],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_user_files_s3_bucket: "virtiuswebappstorage1dd6e-test",
  aws_user_files_s3_bucket_region: "us-west-2",
  Analytics: {
    AWSPinpoint: {
      appId: "5a38305d9d7f496f98823cce7c96c045",
      region: "us-west-2",
    },
  },
};

export default awsmobile;
